import { RouteLocationRaw } from 'vue-router';

import { renderDateTimeRange } from '@rygen/rygen-ui/i18n';
import { ZonedDateTimeRange } from '@rygen/rygen-ui/model';
import { stringify } from '@rygen/rygen-ui/util';
import { ZonedDateTimeRange as EsZonedDateTimeRange } from '@rygen/tms-search-model/search/zonedDateTimeRange';

import { OrderSearchCriteria, ShipmentSearchCriteria } from '@/model';
import { ShipOrderSearchCriteria } from '@/model/consolidation';

type RouteWithSearchQuery =
  'orderList' | 'shipmentList' | 'shipOrderConsolidation';

type SearchCriteria =
  OrderSearchCriteria | ShipmentSearchCriteria | ShipOrderSearchCriteria;

export function buildSearchRoute(
  to: 'orderList',
  searchParams: Partial<OrderSearchCriteria>,
): RouteLocationRaw;

export function buildSearchRoute(
  to: 'shipmentList',
  searchParams: Partial<ShipmentSearchCriteria>,
): RouteLocationRaw;

export function buildSearchRoute(
  to: 'shipOrderConsolidation',
  searchParams: Partial<ShipOrderSearchCriteria>,
): RouteLocationRaw;

export function buildSearchRoute(
  to: RouteWithSearchQuery,
  searchParams: Partial<SearchCriteria>,
): RouteLocationRaw {
  return {
    name: to,
    query: {
      search: stringify(searchParams),
    },
  };
}

export const formatDateRange = (
  dateRange: ZonedDateTimeRange | EsZonedDateTimeRange | undefined,
  timeZone?: string,
) => {
  return renderDateTimeRange(dateRange, {
    dateFormat: {
      dateStyle: 'short',
    },
    timeFormat: { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' },
    timeZone,
  });
};
